var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verified-card"},[_vm._v(" Template CardVerified App ")])
}
var staticRenderFns = []

export { render, staticRenderFns }